/** Every coding exam asks this many questions. */
export const QUESTION_COUNT = 3;

/** How long the applicant rests between two questions, in seconds. */
export const BREAK_SECONDS = 600;

/** Exam discriminator the proctoring endpoint expects. */
export const PROCTORING_TYPE = 'codingExam';

/** The question endpoint answers `208` when every question has already been answered. */
export const ALREADY_ANSWERED = 208;

/** How often the camera is re-checked, so a revoked permission is noticed quickly. */
export const CAMERA_CHECK_INTERVAL_MS = 1000;

/** Name of the source file the snippet is compiled as, per language. */
export const FILE_NAMES: Record<string, string> = {
    javascript: 'main.js',
    python: 'main.py',
    go: 'main.go',
    cpp: 'main.cpp',
    c: 'main.c',
    csharp: 'main.cs',
};
